import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';

@Component({
  selector: 'app-listaskformoney68',
  templateUrl: './listaskformoney68.component.html',
  styleUrls: ['./listaskformoney68.component.css']
})
export class Listaskformoney68Component implements OnInit, ReactiveFormsModule {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  zone = '';
  supcode = '';
  userlv = 0
  Actiocmanager: UntypedFormGroup;
  adda: UntypedFormGroup;

  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel

    this.Actiocmanager = new UntypedFormGroup({
      comment_takeask: new UntypedFormControl(''),
      comment_takeasks: new UntypedFormControl(''),
      comment_save: new UntypedFormControl(''),
    })
    this.adda = new UntypedFormGroup({
      checkboxControl: new UntypedFormControl(false)
    })
    this.Loadlistaskformoney()
  }
  isYear = ['2526', '6869', '2568/2569', '2567/2568', '68/69', '68'];

  displaylist = ['no', 'ckeackpoint', 'doc_no', 'supportter', 'date', 'fmcode', 'fullname', 'askforunder', 'countmoney', 'status', 'timeline', 'save', 'cancle'];
  n_name = [];

  ngOnInit(): void {
    let uvlv = this.userlv;
    if (uvlv == 5) {
      this.n_name = [{ doc_status: '1', now: 'คนรับเอกสาร', next: 'พนักงานสินเชื่อ' }];
    }
    else if (uvlv == 6) {
      this.n_name = [{ doc_status: '7', now: 'พนักงานสินเชื่อ', next: 'หัวหน้าแผนกสินเชื่อ', next2: 'ผู้ช่วย ผจก.สินเชื่อ' }];
    }
    //this.Loadlistaskformoney();
    this.loadtype_money();
  }
  checkboxControl = false

  edit_st = 0;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.listfinancedata.filter = filterValue;
  }

  Cancleid(data: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data + "&doc_status='X'";

    if (confirm("ต้องการยกเลิกรายการ ?") == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยกเลิกรายการแล้วค่ะ");
          this.Loadlistaskformoney();
        }
        else {
          alert("!!! ไม่สำเร็จ !!!")
        }
      }).catch(err => { throw (err); })
    } else {
      return false;
    }
  }

  // โหลดข้อมูล
  listfinancedata: any;
  listfinancedatadata: any;
  Loadlistaskformoney() {
    this.spinner.show();
    console.log('Loadlistask')
    this.dataAr = []
    // let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?fncode=%27"+ this.zone +"%27&ck_ds1=0"
    let url = ""
    let url1 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance" + this.isYear[1] + "]&w=[doc_status]in('0','2')"
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance" + this.isYear[1] + "]&w=fncode='" + this.zone + "'and[doc_status]in('0','1','2')"

    if (this.userlv == 5) {
      url = url1;
    }
    else if (this.userlv == 6) {
      url = url2;
    }
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      data = data.map(item => {
        return {
          ...item, modify: false
        };
      });
      this.edit_st = 0;
      data.sort((a, b) => {
        return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
      });

      this.listfinancedatadata = data
      this.listfinancedata = new MatTableDataSource(data);
      this.paginator.length = data.length
      this.paginator.pageSize = 10;
      this.listfinancedata.sort = this.sort;
      this.listfinancedata.paginator = this.paginator;
      //console.log('listfinancedatadata',this.listfinancedatadata)
    })
      .catch(err => { throw (err) })
  }

  dataDoc: String
  // รับเรื่องหลายรายการ --
  saveData(status = 1) {
    let data = this.listfinancedata.filteredData.filter((el: any) => el.modify == true);
    let newArray = data.map(item => `'${item.docid}'`);
    //console.log('newArray:', newArray);
    let comment = this.dataDoc;
    // let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_fn11?docid="+ docid + "&comment3="+comment+"&fn_id="+this.supcode;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[getfactor]&s=[fnstatus]=11,[doc_status]=${status},[comment3]='${comment}',[fn_id]='${this.supcode}',[fnAccept]=getdate()&w=[docid]in(${newArray})`
    console.log('saveData_url:', url);
    if (confirm("ยืนยันการทำรายการ " + newArray.length + " รายการ ?")) {
      this.spinner.show();
      axios.post(url).then(res => {
        this.spinner.hide();
        if (res.data.rowsAffected[0] >= 1) {
          alert("ส่งต่อแล้ว");
          this.Loadlistaskformoney();
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
  }

  dataAr = [];
  getdata(docid = '', fmname = '', money_amt = 0, comment1 = '') {
    let datain = { 'docid': docid, 'fmname': fmname, 'money_amt': money_amt, 'comment1': comment1 };
    this.dataAr.push(datain);
    //else if(!ck) this.dataAr.filter(el => el.docid != docid);
    this.dataAr = this.dataAr.filter((v, i, a) => a.findIndex(t => (t.docid === v.docid)) === i);
  }

  deletesomevalue(docid) {
    let data = this.dataAr.filter(el => el.docid != docid);
    this.dataAr = data.sort(function (a, b) {
      return a.docid - b.docid;
    });
  }
  cctest() {
    this.dataAr = [];
    $('input[type=checkbox]').prop('checked', false);
  }

  datatype_m = [];
  subtype0: any
  loadtype_money() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*,left([id],1)[l_id],RIGHT([id],1)[r_id]&f=[CPS6263].[dbo].[type_money]&w=1=1";
    axios.get(url).then(res => {
      this.datatype_m = res.data;
      this.subtype0 = this.datatype_m.filter((el: any) => el.r_id == '0');
    }).catch(err => { throw (err); })

  }
  sc_docA = null
  subtype1 = [];
  subtypeSL: string

  SubTypeSelectM(type0: string) {
    this.listfinancedata = [];
    console.log('type0', type0)
    this.subtype1 = this.datatype_m.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    this.listfinancedata = new MatTableDataSource(this.listfinancedatadata.filter((el: any) => el.type_money.substr(0, 1) == type0));
    this.paginator.length = this.listfinancedata.length
    this.paginator.pageSize = 10;
    this.listfinancedata.sort = this.sort;
    this.listfinancedata.paginator = this.paginator;

  }
  SubTypeSelectS(sc_id: string) {
    this.listfinancedata = [];
    console.log('sc_id', sc_id)
    this.listfinancedata = new MatTableDataSource(this.listfinancedatadata.filter((el: any) => el.type_money == sc_id));
    this.paginator.length = this.listfinancedata.length
    this.paginator.pageSize = 10;
    this.listfinancedata.sort = this.sort;
    this.listfinancedata.paginator = this.paginator;
  }
  resetdata() {
    this.listfinancedata = [];
    console.log('resetdata')
    this.listfinancedata = new MatTableDataSource(this.listfinancedatadata);
    this.paginator.length = this.listfinancedata.length
    this.paginator.pageSize = 10;
    this.listfinancedata.sort = this.sort;
    this.listfinancedata.paginator = this.paginator;

  }

  // รับเรื่อง
  Takeask(docid: any) {
    let comment = this.Actiocmanager.get('comment_takeask').value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_fn11?docid=" + docid + "&comment3=" + comment + "&fn_id=" + this.supcode;

    if (confirm("ยืนยันการทำรายการ ?")) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("รับเรื่องแล้ว");
          setTimeout(() => {
            this.Loadlistaskformoney();
          }, 200);
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
    else {

    }
  }
  
  Takeask0() {//ทดสอบ
    let comment = this.Actiocmanager.get('comment_takeasks').value;
    console.log('log', comment, this.supcode)
    console.log('dataAr', this.dataAr)
    let newArray = this.dataAr.map(item => "'" + item.firebaseid + "'");
    console.log('newArray', newArray);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[getfactor]&s=fnstatus=11,doc_status=1,comment3='" + comment + "',fn_id='" + this.supcode + "',fnAccept=getdate()&w=firebaseid in (" + newArray + ")"
    console.log('url', url);

  }
  // รับเรื่องหลายรายการ
  Takeasks() {
    let comment = this.Actiocmanager.get('comment_takeasks').value;
    let newArray = this.dataAr.map(item => "'" + item.firebaseid + "'");
    // let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_fn11?docid="+ docid + "&comment3="+comment+"&fn_id="+this.supcode;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[getfactor]&s=fnstatus=11,doc_status=1,comment3='" + comment + "',fn_id='" + this.supcode + "',fnAccept=getdate()&w=firebaseid in (" + newArray + ")"
    if (confirm("ยืนยันการทำรายการ " + newArray.length + " รายการ ?")) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          alert("รับเรื่องแล้ว");
          this.Loadlistaskformoney();
        }
        else {
          alert("ไม่สำเร็จกรุณาลองใหม่");
        }
      }).catch(err => { throw (err) })
    }
  }

  // ส่งต่อ
  Sendforward(docid = '', str: number) {
    let sent2 = '', dalv = this.n_name[0];
    if (str == 7) sent2 = dalv.next
    else if (str == 8) sent2 = dalv.next2

    let comment = this.Actiocmanager.get('comment_save').value;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor_n?docid=" + docid + "&doc_status=7&comment3='" + comment + "'&fn_id='" + this.supcode + "'&comment3date=getdate()";
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=${docid}&doc_status='${str}'&comment3='${comment}'&fn_id='${this.supcode}'&comment3date=getdate()`;
    if (confirm("ยืนยันส่งต่อ " + sent2 + "?")) {
      //console.log('Sendforward:', url)
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("ส่งต่อเรียบร้อย");
            this.Loadlistaskformoney();
          }
          else {
            alert("ไม่สำเร็จกรุณาลองใหม่");
          }
        }).catch(err => {
          throw (err)
        })
    }

  }

  // ข้อมูลใน Modal
  datainmodal: any;
  Datainmodel(docid: string) {
    this.datainmodal = this.listfinancedatadata.filter(el => el.firebaseid == docid);
    console.log(this.datainmodal);
  }

  THtoLocalstring(thisdate: any) {
    if (!thisdate) {
      return '';
    }
    const date1 = new Date(thisdate);
    let options: any = {
      // weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      //timeZone: 'UTC' ,     
    };

    return date1.toLocaleString('th-TH', options);
  }

}
